import { PERMISSIONS } from './permissions';

export const MODULE_PERMISSIONS = [
  PERMISSIONS.association.about.view,
  PERMISSIONS.association.instructions.view,
  PERMISSIONS.association.boardMembers.view,
  PERMISSIONS.association.rulesAndRegulationsPage.view,
  PERMISSIONS.members.view,
  PERMISSIONS.newsItems.view,
  PERMISSIONS.roles.view,
  PERMISSIONS.competitions.view,
  PERMISSIONS.competitions.disciplines.view,
];
